type LocalizedLinkLocale = 'en-us' | 'fr' | 'nl';

export const LS_PAY_LINKS = {
  SETUP_LIGHTSPEED_PAYMENTS:
    'https://retail-support.lightspeedhq.com/hc/{{locale}}/articles/360043158154',
  SETUP_LIGHTSPEED_PAYMENTS_HARDWARE:
    'https://retail-support.lightspeedhq.com/hc/{{locale}}/articles/360005481853',
};

export const useLocalizedLink = (
  link: string,
  localeOverrides?: { [key: string]: LocalizedLinkLocale }
) => {
  const localeMap: { [key: string]: string } = {
    en: 'en-us',
    fr: 'fr',
    nl: 'nl',
  };

  const getLanguage = (): string => {
    return window.Localize
      ? window.Localize.getLanguage()
      : window.browserLocale().replace(/-.+/, '');
  };

  const getLocale = (language: string): string => {
    let locale = localeMap[language] || localeMap.en;
    if (localeOverrides !== undefined && locale in localeOverrides) {
      locale = localeOverrides[locale];
    }
    return locale;
  };

  if (link.includes('{{locale}}')) {
    const language = getLanguage();
    const locale = getLocale(language);
    return link.replace('{{locale}}', locale);
  }

  return link;
};

export default useLocalizedLink;
